import { bootstrapClientTheme, extractNextDataThemeBootstrap } from './prewarm-client-utils';

if (typeof window !== 'undefined') {
  const theme = extractNextDataThemeBootstrap(window);
  if (theme) {
    await bootstrapClientTheme(theme);
  }
}
